export default "__VITE_ASSET__BwoVMQui__"